import { render, staticRenderFns } from "./drainDialog.vue?vue&type=template&id=c37c96a8"
import script from "./drainDialog.vue?vue&type=script&lang=js"
export * from "./drainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports